<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>权限管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">门店</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow && !hideInUserEdit">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-select
            placeholder="请选择项目"
            v-model="project_id"
            showSearch
            style="min-width: 200px; margin-right: 20px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in projectList"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <a
            ><a-input placeholder="门店名称|地址|区域" v-model="query_field"
          /></a>
        </span>
        <span>
          <a-button style="margin-right: 10px" @click="clearSearch"
            >重置</a-button
          >
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>
                {{
                  item.province == "上海市" ||
                  item.province == "重庆市" ||
                  item.province == "天津市" ||
                  item.province == "北京市"
                    ? item.province + item.area + item.address
                    : item.province + item.city + item.area + item.address
                }}
              </td>
              <td>{{ item.name }}</td>
              <td style="max-width: 30%">{{ item.guard_user_name }}</td>
              <td class="operation">
                <a @click="edit(item)">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>

    <!-- 增加 -->
    <addShop v-on:hideInAdd="hideInAdd" v-show="hideInAddShow" />
    <!-- 增加 end-->
    <!-- 编辑 -->
    <shopEdit
      v-on:hideInEdit="hideInEdit"
      v-show="hideInUserEdit"
      :editDetail="editDetail"
    />
    <!-- 编辑  end-->
  </div>
</template>
<script>
import axios from "axios";
import addShop from "@/components/retail/addShop"; //增加
import shopEdit from "@/components/retail/shopEdit"; //编辑
import { mapState } from "vuex";
export default {
  components: {
    addShop,
    shopEdit
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      typeSearch: -1,
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      thList: ["项目", "区域", "门店名称", "员工", "操作"],
      projectList: [],
      project_id: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    clearSearch() {
      this.query_field = "";
      this.project_id = "";
      this.page = 1;
      this.getData();
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.retail + "Retail_shop/lists";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          project_id: this.project_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      a,
      label {
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
